import { getTimestampFromUTCString } from "../../../utils/displayTime";

const chartTypesObj = {
  rxTx: "Rx + Tx",
  rx: "Rx utilization (%)",
  tx: "Tx utilization (%)"
};

export const chartTypes = Object.entries(chartTypesObj).map(item => ({
  value: item[0],
  label: item[1]
}));

export const setChartDataReport = (resData, circuits) => {
  const circuitMap = Object.fromEntries(circuits.map(item => ([
    item.circuit_name,
    {
      name: item.circuit_display_name,
      rx: item.bandwidth_downstream,
      isValidRx: Number.isFinite(item.bandwidth_downstream)
        && item.bandwidth_downstream !== 0,
      tx: item.bandwidth_upstream,
      isValidTx: Number.isFinite(item.bandwidth_upstream)
        && item.bandwidth_upstream !== 0
    }
  ])));
  for (const item of resData) {
    item.date = getTimestampFromUTCString(item.entry_ts);
    const circuit = circuitMap[item.circuit_name];

    Object.assign(item, { name: circuit?.name ? circuit.name : item.circuit_display_name, rxTx: item.total_bps });
    item.name = circuit?.name ? circuit.name : item.circuit_display_name;
    if (circuit?.isValidRx === true)
      item.rx =
        parseFloat(((item.rx_bps / (circuit.rx * 10))).toFixed(2))
    if (circuit?.isValidTx === true)
      item.tx =
        parseFloat(((item.tx_bps / (circuit.tx * 10))).toFixed(2))
  }

  return resData;
};
